import React from "react";
import { Button, Modal } from "react-bootstrap";

const RubricsModal = (props) => {
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="rubrics-modal"
      >
        <div className="p-3" closeButton>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h1 className="font-16 font-weight-s-bold heading-color mb-0">
              Rubrics:
            </h1>
            <img src="/assets/images/cross-icon.svg" alt="" onClick={props.onHide} />
          </div>
          <div className="mb-3">
            <div className="font-13 font-weight-normal heading-color">
              1 = Unacceptable
            </div>
            <ul className="font-13 font-weight-normal text-color">
              <li>Does not perform the job satisfactorily</li>
              <li>
                Does not produce the quantity, quality, and timeliness of work
                expected
              </li>
            </ul>
          </div>
          <div className="mb-3">
            <div className="font-13 font-weight-normal heading-color">
              2 = Needs Improvement​
            </div>
            <ul className="font-13 font-weight-normal text-color">
              <li>
                Some improvement in the quality, quantity, and/or timeliness of
                work is important
              </li>
              <li>
                Regular work and projects are not consistently completed on
                schedule​
              </li>
            </ul>
          </div>
          <div className="mb-3">
            <div className="font-13 font-weight-normal heading-color">
              3 = Meets Expectations​
            </div>
            <ul className="font-13 font-weight-normal text-color">
              <li>Is doing a satisfactory job​</li>
              <li>
                Handles most assignments within the scope of his/her
                responsibility​
              </li>
              <li>Does not require significant improvement​</li>
              <li>
                Typically completes regular work and projects on schedule​
              </li>
            </ul>
          </div>
          <div className="mb-3">
            <div className="font-13 font-weight-normal heading-color">
              4 = Exceeds Expectations​
            </div>
            <ul className="font-13 font-weight-normal text-color">
              <li>
                Is doing an excellent job and usually exceeds most requirements​
              </li>
              <li>
                Demonstrates a willingness to perform beyond expectations​
              </li>
              <li>Takes initiative in asking for additional responsibility​</li>
            </ul>
          </div>
          <div className="mb-3">
            <div className="font-13 font-weight-normal heading-color">
              5 = Outstanding​
            </div>
            <ul className="font-13 font-weight-normal text-color">
              <li>
                Exceeds position requirements even on the most difficult and complex aspects of his/her job​
              </li>
              <li>
                Consistently accomplishes more than expected​
              </li>
              <li>Takes on additional assignments without negatively affecting other work​</li>
              <li>Completes projects thoroughly, completely, and on or ahead of schedule​​</li>
            </ul>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default RubricsModal;
